import { Reader, Writer } from "protobufjs/minimal";
import type {
  Gender,
  CustomerGender,
  Device,
  CarrierName,
  CurrencyCode,
  RequestConfig,
  CustomerSession,
  GuestSession,
} from "../../protos/shared/shared.types";

export const decodeGender = (reader: Reader): Gender => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    default:
      return 0;
  }
};

export const encodeGender = (writer: Writer, value: Gender): Writer => {
  return writer.int32(value);
};

export const decodeCustomerGender = (reader: Reader): CustomerGender => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    default:
      return 0;
  }
};

export const encodeCustomerGender = (
  writer: Writer,
  value: CustomerGender
): Writer => {
  return writer.int32(value);
};

export const decodeDevice = (reader: Reader): Device => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    default:
      return 0;
  }
};

export const encodeDevice = (writer: Writer, value: Device): Writer => {
  return writer.int32(value);
};

export const decodeCarrierName = (reader: Reader): CarrierName => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    case 6:
      return 6;
    case 7:
      return 7;
    case 8:
      return 8;
    case 9:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
    case 14:
      return 14;
    case 15:
      return 15;
    case 16:
      return 16;
    case 17:
      return 17;
    case 18:
      return 18;
    case 19:
      return 19;
    case 20:
      return 20;
    case 21:
      return 21;
    case 22:
      return 22;
    case 23:
      return 23;
    case 24:
      return 24;
    case 25:
      return 25;
    case 26:
      return 26;
    case 27:
      return 27;
    case 28:
      return 28;
    case 29:
      return 29;
    case 31:
      return 31;
    case 32:
      return 32;
    case 33:
      return 33;
    case 34:
      return 34;
    case 35:
      return 35;
    case 36:
      return 36;
    case 37:
      return 37;
    case 38:
      return 38;
    case 39:
      return 39;
    case 40:
      return 40;
    case 41:
      return 41;
    case 42:
      return 42;
    case 43:
      return 43;
    case 44:
      return 44;
    case 45:
      return 45;
    case 46:
      return 46;
    case 47:
      return 47;
    case 48:
      return 48;
    case 49:
      return 49;
    case 50:
      return 50;
    case 51:
      return 51;
    case 52:
      return 52;
    case 53:
      return 53;
    case 54:
      return 54;
    case 55:
      return 55;
    default:
      return 0;
  }
};

export const encodeCarrierName = (
  writer: Writer,
  value: CarrierName
): Writer => {
  return writer.int32(value);
};

export const decodeCurrencyCode = (reader: Reader): CurrencyCode => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    case 6:
      return 6;
    case 7:
      return 7;
    case 8:
      return 8;
    case 9:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
    case 14:
      return 14;
    default:
      return 0;
  }
};

export const encodeCurrencyCode = (
  writer: Writer,
  value: CurrencyCode
): Writer => {
  return writer.int32(value);
};

export const createBaseRequestConfig = (): RequestConfig => {
  return {
    childShopId: 0,
    shopId: 0,
    device: 0,
  };
};

export const decodeRequestConfig = (
  reader: Reader,
  length: number
): RequestConfig => {
  const end = reader.pos + length;
  const message = createBaseRequestConfig();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.childShopId = reader.int32();

        break;
      case 2:
        message.shopId = reader.int32();

        break;
      case 5:
        message.device = decodeDevice(reader);

        break;
      case 3:
        message.session = {
          $case: "customerSession",
          customerSession: decodeCustomerSession(reader, reader.uint32()),
        };

        break;
      case 4:
        message.session = {
          $case: "guestSession",
          guestSession: decodeGuestSession(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeRequestConfig = (
  writer: Writer,
  message: RequestConfig
): Writer => {
  writer.uint32(8).int32(message.childShopId);
  writer.uint32(16).int32(message.shopId);
  encodeDevice(writer.uint32(40), message.device);
  if (message.session !== undefined) {
    switch (message.session.$case) {
      case "customerSession":
        encodeCustomerSession(
          writer.uint32(26).fork(),
          message.session.customerSession
        ).ldelim();

        break;
      case "guestSession":
        encodeGuestSession(
          writer.uint32(34).fork(),
          message.session.guestSession
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseCustomerSession = (): CustomerSession => {
  return {
    authToken: "",
  };
};

export const decodeCustomerSession = (
  reader: Reader,
  length: number
): CustomerSession => {
  const end = reader.pos + length;
  const message = createBaseCustomerSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.authToken = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCustomerSession = (
  writer: Writer,
  message: CustomerSession
): Writer => {
  writer.uint32(10).string(message.authToken);

  return writer;
};

export const createBaseGuestSession = (): GuestSession => {
  return {
    sessionId: "",
  };
};

export const decodeGuestSession = (
  reader: Reader,
  length: number
): GuestSession => {
  const end = reader.pos + length;
  const message = createBaseGuestSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.sessionId = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeGuestSession = (
  writer: Writer,
  message: GuestSession
): Writer => {
  writer.uint32(10).string(message.sessionId);

  return writer;
};
